'use client'

import * as React from 'react'
import {
  isYouTubeUrl,
  toYouTubeEmbedSrc,
} from '@/tiptap/tiptap-extensions/common/SlashCommand/groups'
import { VideoDialog } from '@/tiptap/tiptap-ui/video-dialog/video-dialog'
import { Editor } from '@tiptap/react'

interface VideoManagerProps {
  editor: Editor
}

export function VideoManager({ editor }: VideoManagerProps) {
  const [isOpen, setIsOpen] = React.useState(false)

  React.useEffect(() => {
    const handleOpenDialog = () => setIsOpen(true)

    editor.on('openVideoDialog', handleOpenDialog)

    return () => {
      editor.off('openVideoDialog', handleOpenDialog)
    }
  }, [editor])

  const handleInsert = React.useCallback(
    (url: string) => {
      if (isYouTubeUrl(url)) {
        const embedSrc = toYouTubeEmbedSrc(url)
        if (embedSrc) {
          editor
            .chain()
            .focus()
            .insertContent({
              type: 'youtube',
              attrs: { src: embedSrc },
            })
            .run()
          setIsOpen(false)
          return
        }
      }

      editor
        .chain()
        .focus()
        .insertVideo({
          src: url,
          width: '100%',
          height: 'auto',
          align: 'center',
        })
        .run()
      setIsOpen(false)
    },
    [editor]
  )

  return (
    <VideoDialog
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      onSubmit={handleInsert}
    />
  )
}
